
import DtoDetailCompanyFollowUpRecord from "@/models.machine/DtoDetailCompanyFollowUpRecord";
import { EnumCompanyType } from "@/models.machine/EnumCompanyType";
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import CompanyFollowUpRecordDetail from "../../CompanyFollowUpRecord/CompanyFollowUpRecordDetail.vue";
import MiezzForm from "@/models/MiezzForm";
@Options({
  components: {
    CompanyFollowUpRecordDetail,
  },
})
export default class CustomerCompanyFollowUpRecordEdit extends Vue {
  type = EnumCompanyType.Customer;
  detail = new MiezzForm<DtoDetailCompanyFollowUpRecord, string>(
    "CustomerManagement_FollowUpRecord_Detail"
  );
}
